//
//
//
//
//
//
import { getAction } from '@/api/manage'; // import moment from 'moment'

import warnDataModal from '@views/online/component/warnDataModal.vue';
export default {
  components: {
    warnDataModal: warnDataModal
  },
  data: function data() {
    return {
      timer: null,
      show: false,
      warnData: {},
      dragging: false,
      offset: {
        x: 0,
        y: 0
      },
      style: {
        position: 'absolute',
        top: '100'
      }
    };
  },
  created: function created() {
    var _this = this;

    this.getList();
    this.timer = setInterval(function () {
      _this.getList();
    }, 1000 * 60);
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      if (localStorage.getItem('pro__Access-Token') && localStorage.getItem('pro__Access-Token') != 'null' && localStorage.getItem('pro__Access-Token') != 'undefined') {
        getAction('/online/warn', {
          st: 31,
          scope: 4,
          scopeId: 5,
          warnStatus: 1,
          category: 1,
          size: 1,
          column: 'warn_time',
          order: 'desc'
        }).then(function (res) {
          if (res.success) {
            if (res.result && res.result.records && res.result.records.length > 0) {
              // var fiveMinutesAgo = moment().subtract(5, 'minutes').unix()
              // var warnTime = res.result.records[0].warnTime ? moment(res.result.records[0].warnTime).unix() : 0
              // if(warnTime > fiveMinutesAgo){
              _this2.show = true;
              _this2.warnData = res.result.records[0]; // }else {
              //   this.show = false
              // }
            } else {
              _this2.show = false;
            }
          }
        });
      } else {
        this.show = false;
      }
    },
    onToDetail: function onToDetail() {
      this.$refs.warnDataModalRef.onToChangeData(this.warnData);
    },
    dragStart: function dragStart(e) {
      e.preventDefault();
      this.dragging = true;
      var rect = this.$el.getBoundingClientRect();
      this.offset.x = e.clientX - rect.left;
      this.offset.y = e.clientY - rect.top;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('touchmove', this.drag);
      document.addEventListener('mouseup', this.dragEnd);
      document.addEventListener('touchend', this.dragEnd);
    },
    drag: function drag(e) {
      if (this.dragging) {
        var x = e.clientX - this.offset.x;
        var y = e.clientY - this.offset.y;
        var maxX = window.innerWidth - this.$el.offsetWidth;
        var maxY = window.innerHeight - this.$el.offsetHeight;
        this.style.top = Math.min(maxY, Math.max(0, y)) + 'px';
      }
    },
    dragEnd: function dragEnd() {
      this.dragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('touchmove', this.drag);
      document.removeEventListener('mouseup', this.dragEnd);
      document.removeEventListener('touchend', this.dragEnd);
    }
  }
};